import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/baseUi/tabs"
import { word } from "@modules/core/utils/i18n"
import { BoxArchivedMembersTable } from "@modules/members/boxTerminatedMembers/components/boxArchivedMembersTable"
import { BoxArchivedStaffTable } from "@modules/members/boxTerminatedMembers/components/boxArchivedStaffTable"
import {
  usePersistedBoxArchivedMembers,
  usePersistedBoxArchivedStaffMembers,
} from "@modules/members/boxTerminatedMembers/hooks/useBoxArchivedMembers"
import { startTransition, useEffect, useState } from "react"

type BoxArchivedMembersAndStaffProps = {
  setCountTab: (count: number) => void
} & React.ComponentProps<"div">

enum ArchivedTab {
  MEMBERS = "members",
  STAFF = "staff",
}

export function BoxArchivedMembersAndStaff({ setCountTab }: BoxArchivedMembersAndStaffProps) {
  const [tab, setTab] = useState<ArchivedTab>(ArchivedTab.MEMBERS)

  const { totalElements: totalArchivedMembers } = usePersistedBoxArchivedMembers()
  const { totalElements: totalArchivedStaffMembers } = usePersistedBoxArchivedStaffMembers()

  const handleTabChange = (newTab: ArchivedTab) => {
    startTransition(() => {
      setTab(newTab)
    })
  }

  useEffect(() => {
    let count = 0

    if (totalArchivedMembers) count += totalArchivedMembers
    if (totalArchivedStaffMembers) count += totalArchivedStaffMembers

    setCountTab(count)
  }, [setCountTab, totalArchivedMembers, totalArchivedStaffMembers])

  return (
    <Tabs defaultValue={tab}>
      <TabsList variant="roundedButton" className="w-full">
        <TabsTrigger
          variant="roundedButton"
          onClick={() => handleTabChange(ArchivedTab.MEMBERS)}
          value={ArchivedTab.MEMBERS}
          className="capitalize"
        >
          {word("global.member", { count: 2 })}
        </TabsTrigger>
        <TabsTrigger
          variant="roundedButton"
          onClick={() => handleTabChange(ArchivedTab.STAFF)}
          value={ArchivedTab.STAFF}
          className="capitalize"
        >
          {word("global.staff")}
        </TabsTrigger>
      </TabsList>
      <TabsContent value={ArchivedTab.MEMBERS} className="flex w-full">
        <BoxArchivedMembersTable />
      </TabsContent>
      <TabsContent value={ArchivedTab.STAFF} className="flex w-full">
        <BoxArchivedStaffTable />
      </TabsContent>
    </Tabs>
  )
}
